import React, { useCallback } from "react";
import { ROTATION_CONFIG } from "../constants";

interface RotationControllerProps {
  onChange: (rotation: number) => void;
  style?: React.CSSProperties;
}

/**
 * 回転コントロール UI コンポーネント
 */
const RotationController: React.FC<RotationControllerProps> = ({ onChange, style }) => {
  const rotateLeft = useCallback(() => {
    onChange(-ROTATION_CONFIG.STEP_DEGREES);
  }, [onChange]);

  const rotateRight = useCallback(() => {
    onChange(ROTATION_CONFIG.STEP_DEGREES);
  }, [onChange]);

  const resetRotation = useCallback(() => {
    onChange(0);
  }, [onChange]);

  return (
    <div
      style={{
        display: "flex",
        gap: 6,
        ...style,
      }}
    >
      <button onClick={rotateLeft}>⟲</button>
      <button onClick={resetRotation}>⟳0°</button>
      <button onClick={rotateRight}>⟳</button>
    </div>
  );
};

export default RotationController;
